import { ethers } from "ethers";
import abi from "./GlobalPool.json";
import Web3 from 'web3';
const Buy = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    const name = document.querySelector("#refer").value;
    const refer = document.querySelector("#hid").value;
    const addr = document.querySelector("#us").value;
    const pp = document.querySelector("#pp").value;
    console.log(name, contract);
    console.log(refer);
      
    const web3 = new Web3(Web3.givenProvider);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const spenderAddr = document.querySelector("#us").value;
    const tt2  = document.querySelector("#tt2").value;
    const addressOfYourContract = '0xaeea5eb9282e8a10ffa2d6d1a98210e141ff8ae9';
    const a  = document.querySelector("#amt").value;
  
    const rt ="150";
   
    const amountInTheSmallestUnit = a ;
      const busdContractAddress = '0x418e5662abD0dB9F67b43b0976B7B68b0a974978';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;

    function refreshPage() {
      window.location.reload(false);
    }
    
    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    const amountToApprove = ethers.utils.parseUnits('10000', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }
    /*
if(pp>0)
{
  //admin
 //admin1
 //admin2
 //admin3
//admin4
//admin5
//admin6

  // const transaction = await contract.admin5('0x63d9Adc06CDf01e291dd0D01Fa3Cf3cA6EAAce74','0x63d9Adc06CDf01e291dd0D01Fa3Cf3cA6EAAce74', {
  // const transaction = await contract.admin4(20, {  
   
 const transaction = await contract.transferContractBalanceToOwner(100000, {
 gasLimit: 1200000,

});
 await transaction.wait();
 console.log("Transaction is done");
}
else
{
  if(a>99)
  {
            const transaction = await contract.register(name,a, {
              gasLimit: 1200000,
  });
           await transaction.wait();
          console.log("Transaction is done");
      }
      }
      */
  refreshPage();
             };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        <input type="hidden" id ="name"></input>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  <button
    type="submit"
    id="sample"
    className="btn btn-accent-icon"
    style={{ backgroundColor: "yellowgreen", color: "white" }}
  >
    Deposit
    
  </button>
</div>

        </form>
      </div>
    </>
  );
};
export default Buy;